import React, { useState, useEffect } from "react";
import { Col, Flex, Modal, Row } from "antd";
import { PageContent, PageSection, PageTitle } from "../../../../styles/global/Pages.styled";
import { Text } from "../../Atomics/Text";
import { EditTable } from '@synergy/table';
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import useFetch from "../../../../server/useFetch";
import query from "../../../../server/constants.api";
import { FormModal } from "../../Atomics/FormModal";
import axiosInstance from "../../../../server/axiosInstance";

// Function to handle user editing
const editUser = async (data) => {
    // Make PUT request to update user data
    const { data: response } = axiosInstance('PUT', query.path.authenticateUser, data);
    return response.data;
};

// Access component
export const Access = () => {
    const { t } = useTranslation(); // Translation hook

    // State variables
    const [fetchedData, setFetchData] = useState(null);
    const { data: usersListData, isLoading: usersListIsLoading, refetch: refetchUsersList } = useFetch(query.path.usersList, 'getUsersList', { language: i18next.resolvedLanguage, userId: 'usersTable' });

    // const { data: editUser } = useFetch(query.path.usersList, 'editUser', { language: i18next.resolvedLanguage, userId: 'usersTable' })

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    // const [values, setValues] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null); // Estado para armazenar o usuário selecionado
    const handleSubmit = (values) => {
        const deloitte = editUser(values); // Edit user data
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setOpen(false); // Close modal after editing
        }, 3000);
    };

    // Effect to handle fetched users list
    useEffect(() => {
        if (usersListData?.data) {
            setFetchData(usersListData?.data);
        }
    }, [usersListData])

    return (
        <PageContent id='registerTable' $backgroundColor='white' >
            <PageSection>
                {/* Page title */}
                <Flex align="center" justify="space-between">
                    <PageTitle>
                        <div className="title">
                            <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginRight='s03'>
                                {t('usersList')} </Text>
                        </div>
                    </PageTitle>
                </Flex>
                {/* Table section */}
                <Row gutter={[32, 32]} style={{ width: '99%' }}>
                    <Col span={24}>
                        {/* addFunction={()=> navigate('/home/register/registerDetail/')} */}
                        {fetchedData ?
                            <EditTable fetchData={fetchedData} language={i18next.resolvedLanguage} tableId='usersTable' editButton={true} handleEdit={(record) => {setOpen(true); setSelectedUser(record)}} hidePagination={true} />
                            : null}
                        {/* Modal for editing user */}
                        <Modal
                            title={t('edit')}
                            centered
                            open={open}
                        // onOk={() => setOpen(false)}
                        onCancel={() => setOpen(false)}
                        footer={null}
                        >
                            <FormModal
                                onFinish={handleSubmit}
                                data={{
                                    initialValues: {
                                        'username': selectedUser?.username ?? '',
                                        'email': selectedUser?.email ?? '',
                                        'tenant': selectedUser?.tenant ? JSON.parse(selectedUser?.tenant) : [],
                                        'phone': selectedUser?.phone ?? ''
                                    },// Pass initial values to form
                                    layout: {
                                        labelCol: 6,
                                        wrapperCol: 12,
                                        layout: 'horizontal',
                                    },
                                    items: [
                                        {
                                            label: t('username'),
                                            input: 'input',
                                            name: 'username',
                                            key: 0
                                        },
                                        {
                                            label: t('email'),
                                            input: 'input',
                                            name: 'email',
                                            key: 1
                                        },
                                        {
                                            label: 'Tenants',
                                            input: 'multipleSelect',
                                            options: ["TOP/ADEPORTO/MAIA", "TOP/ADEPORTO/PORTO/CM PORTO"],
                                            name: 'tenant',
                                            key: 2
                                        },
                                        {
                                            label: t('phoneNumber'),
                                            input: 'input',
                                            name: 'phone',
                                            key: 3
                                        }
                                    ]
                                }} />
                        </Modal>
                    </Col>
                </Row>
            </PageSection>
        </PageContent >
    )
};
